import { SxProps } from '@mui/material';
import { useDebounce } from 'hooks';
import { useState } from 'react';
import { Icon, Input } from 'ui';

export type SearchProps = {
  searchValue: string;
  onSearchChange: (search: string) => void;
  placeholder?: string;
  sx?: SxProps;
};

export const SearchInput = ({ searchValue, onSearchChange, placeholder, sx }: SearchProps) => {
  const [value, setValue] = useState(searchValue);
  useDebounce(value, 500, onSearchChange);

  return (
    <Input
      type="text"
      value={value}
      onChange={event => setValue(event.currentTarget.value)}
      placeholder={placeholder ?? 'Search...'}
      fullWidth
      startAdornment={<Icon name="search" />}
      sx={sx}
    />
  );
};
